import { Card } from "../../../../../components/Card";
import { NavigationTabs } from "../../../../../components/NavigationTabs";
import scopeThreePreviewRegistry from "./scopeThreePreviewRegistry";
import { t } from "i18next";
import { SCOPE_3_CATEGORIES_KEYS, SCOPE_3_CATEGORIES_SEQUENCE } from "./const";
import ManualEmissionsList from "../shared/ManualEmissionsList";

// Map Scope 3 frontend keys → backend ScopeCategoryKey enum names.
// `purchasedGoodsAndServicesDto` is a quirk of the existing report DTO; manual
// emissions for that category are stored under `PURCHASED_GOODS_AND_SERVICES`.
const CATEGORY_KEY_TO_SCOPE_ENUM = Object.freeze({
  purchasedGoodsAndServicesDto: "PURCHASED_GOODS_AND_SERVICES",
  capitalGoods: "CAPITAL_GOODS",
  fuelAndEnergyRelatedActivities: "FUEL_AND_ENERGY_RELATED_ACTIVITIES",
  upstreamTransportationAndDistribution: "UPSTREAM_TRANSPORTATION_AND_DISTRIBUTION",
  wasteGeneratedInOperations: "WASTE_GENERATED_IN_OPERATIONS",
  businessTravel: "BUSINESS_TRAVEL",
  employeeCommuting: "EMPLOYEE_COMMUTING",
  upstreamLeasedAssets: "UPSTREAM_LEASED_ASSETS",
  downstreamTransportationAndDistribution: "DOWNSTREAM_TRANSPORTATION_AND_DISTRIBUTION",
  processingOfSoldProducts: "PROCESSING_OF_SOLD_PRODUCTS",
  useOfSoldProducts: "USE_OF_SOLD_PRODUCTS",
  treatmentOfSoldProducts: "TREATMENT_OF_SOLD_PRODUCTS",
  downstreamLeasedAssets: "DOWNSTREAM_LEASED_ASSETS",
  franchises: "FRANCHISES",
  investments: "INVESTMENTS"
});

function withManualEmissions(Component, manualEmissionsForCategory) {
  function CategoryWithManualEmissions(props) {
    return (
      <>
        <Component {...props} />
        <ManualEmissionsList items={manualEmissionsForCategory} />
      </>
    );
  }
  return CategoryWithManualEmissions;
}

function mapData(categories, reportId, manualEmissions) {
  const elements = [];
  const allManual = manualEmissions ?? [];

  Object.keys(SCOPE_3_CATEGORIES_KEYS).forEach(key => {
    const Component = scopeThreePreviewRegistry.resolve(key);
    const scopeEnum = CATEGORY_KEY_TO_SCOPE_ENUM[key];
    const manualForCategory = allManual.filter(item => item.scopeCategoryKey === scopeEnum);

    elements.push({
      component: withManualEmissions(Component, manualForCategory),
      data: categories[key],
      reportId: reportId,
      id: key,
      name: `Category ${SCOPE_3_CATEGORIES_SEQUENCE.indexOf(key) + 1}`,
      customTabPanelTitle: t(`reportsPage.scopeThree.categories.${key}`),
      customTabListSubTitle: t(`reportsPage.scopeThree.categories.${key}`).split(":")[1]
    });
  });
  return elements;
}

function ScopeThree({ data, reportId, manualEmissions }) {
  const categoryElements = mapData(data, reportId, manualEmissions);

  return (
    <Card boxShadow="xs">
      <NavigationTabs
        elements={categoryElements}
        tabTitle={"Category"}
        subTitleAttribute={"name"}
        navTabPanelStyles={{paddingInlineStart: 5, paddingInlineEnd: 0}}
      />
    </Card>
  );
}

export default ScopeThree;